import React, { useEffect, useState } from "react";
import LoadingIndicator from "../../LoadingIndicator";
import "./pdfviewer.scss";
import { getSignedUrl } from "../../../backend/upload_file";
import download_icon from "../../../../assets/icons/download.svg";

function PdfViewer({ url }) {
    const [isLoading, setIsLoading] = useState(true);
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState("");
    const [reload, setReload] = useState(false);

    const [signedUrl, setSignedUrl] = useState("");
    const [loadingSignedUrl, setLoadingSignedUrl] = useState(false);

    useEffect(() => {
        if (isLoading && !loaded) {
            const failTimeout = setTimeout(() => {
                // setError("Parece que no está funcionado, cierra este visor y vuélvelo a abrir");
                setReload(true);
                setTimeout(() => {
                    setReload(false);
                }, 1);
            }, 5000);
            return () => {
                clearTimeout(failTimeout);
            };
        } else {
            setError("");
        }
    }, [isLoading, loaded, reload]);

    useEffect(() => {
        setLoadingSignedUrl(true);
        setSignedUrl("");

        if (url) {
            getSignedUrl(url).then((res) => {
                setSignedUrl(res.data.signedUrl);
                setLoadingSignedUrl(false);
            });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url]);

    const iframeUrl = `https://docs.google.com/gview?url=${encodeURIComponent(
        signedUrl
    )}&embedded=true`;

    const downloadFile = () => {
        const url_download = signedUrl;

        const link = document.createElement("a");

        //console.log("url ->", url_download);
        link.setAttribute("href", url_download);
        // link.setAttribute('download', `prueba`)
        // link.setAttribute('target', '_blank');

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);
    };

    return (
        <>
            {!reload && (
                <>
                    {loadingSignedUrl ? (
                        <div className="flex flex-col justify-center items-center w-full h-full mt-4">
                            {!loaded && (
                                <LoadingIndicator
                                    size={50}
                                    color="var(--color-primary-dark)"
                                    loading={loadingSignedUrl}
                                />
                            )}
                            <div className="text-xs">{error}</div>
                        </div>
                    ) : (
                        <div className="document-viewer">
                            <iframe
                                title={"Documento"}
                                onLoad={() => {
                                    setIsLoading(false);
                                    setLoaded(true);
                                }}
                                src={iframeUrl}
                                className="w-full h-full"
                                style={{
                                    display: loadingSignedUrl
                                        ? "none"
                                        : "block",
                                }}
                            ></iframe>
                            <div className="actions">
                                <button
                                    className="btn_primary"
                                    onClick={() => downloadFile()}
                                >
                                    <img src={download_icon} alt="Descargar" />
                                    DESCARGAR
                                </button>
                            </div>
                        </div>
                    )}
                </>
            )}
        </>
    );
}

// eslint-disable-next-line no-func-assign
export default PdfViewer = React.memo(PdfViewer);
